import type { HordeGameIntentDocument } from '@animus/type/domain';

const INTENT_STATUS_RANK: Readonly<Record<HordeGameIntentDocument['status'], number>> = {
    accepted: 2,
    pending: 0,
    rejected: 1,
};

/** Selects the authoritative intent state without consulting untrusted wall-clock timestamps. */
export function resolveHordeIntentConflict<T extends HordeGameIntentDocument>(
    newDocumentState: T,
    realMasterState: T
): T {
    const newRank = INTENT_STATUS_RANK[newDocumentState.status];
    const masterRank = INTENT_STATUS_RANK[realMasterState.status];

    if (newRank !== masterRank) {
        return newRank > masterRank ? newDocumentState : realMasterState;
    }

    if (newDocumentState.status === 'accepted' && realMasterState.status === 'accepted') {
        return (newDocumentState.acceptedRevision ?? 0) > (realMasterState.acceptedRevision ?? 0)
            ? newDocumentState
            : realMasterState;
    }

    return realMasterState;
}
